const dayMonth = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
})

/** "Aug 27". Bare dates from the API are date-only, so parse them as local. */
export function shortDate(iso: string | null): string {
  if (!iso) return ''
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return ''
  return dayMonth.format(new Date(y, m - 1, d))
}

/** "in 3 days", "2 days ago", "today" — for a deadline somebody is judging. */
export function relativeDays(iso: string | null): string {
  if (!iso) return ''
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return ''
  const then = new Date(y, m - 1, d)
  const now = new Date()
  const days = Math.round(
    (then.setHours(0, 0, 0, 0) - now.setHours(0, 0, 0, 0)) / 86_400_000,
  )
  if (days === 0) return 'today'
  if (days === 1) return 'tomorrow'
  if (days === -1) return 'yesterday'
  return days > 0 ? `in ${days} days` : `${-days} days ago`
}
